import { getTimeLeft } from '#utils';
import Typography from '#components/typography/Typography';
import { getDaysLeft } from '#utils/getTimeLeft';
import useTranslation from 'next-translate/useTranslation';

type Props = {
  date?: string;
};

const RentingTimeNotification = ({ date }: Props) => {
  const { t } = useTranslation();
  const { days, hours, minutes } = getTimeLeft(date);

  if (!date || (days === 0 && hours === 0 && minutes === 0)) {
    return null;
  }

  if (days >= 3) {
    return (
      <Typography fontSize="small" classes="tw-mb-1">
        {t('rentingTimeNotification', {
          time: `${getDaysLeft(date, Math.round)} ${t('days', {
            count: days,
          })}`,
        })}
      </Typography>
    );
  }

  if (days >= 1) {
    return (
      <Typography fontSize="small" classes="tw-mb-1">
        {t('rentingTimeNotification', {
          time: `${days} ${t('days', { count: days })} ${hours} ${t('hours', {
            count: 10,
          })}`,
        })}
      </Typography>
    );
  }

  if (days === 0 && hours >= 12) {
    return (
      <Typography fontSize="small" classes="tw-mb-1">
        {t('rentingTimeNotification', {
          time: `${hours} ${t('hours', { count: hours })}`,
        })}
      </Typography>
    );
  }

  if (days === 0 && hours < 12 && hours > 0) {
    return (
      <Typography fontSize="small" classes="tw-mb-1">
        {t('rentingTimeNotification', {
          time: `${hours} ${t('hours', { count: hours })} ${minutes} ${t(
            'minutes',
            { count: minutes }
          )}`,
        })}
      </Typography>
    );
  }

  if (days === 0 && hours === 0) {
    return (
      <Typography fontSize="small" classes="tw-mb-1">
        {t('rentingTimeNotification', {
          time: `${minutes} ${t('minutes', { count: minutes })}`,
        })}
      </Typography>
    );
  }

  return null;
};

export default RentingTimeNotification;
